
export const getFirstQueryOf = (docNode) => {
  const [ first ] = docNode.definitions;
  return first;
};

export const getFirstQueryNameOf = (docNode) => {
  const { name } = getFirstQueryOf(docNode);
  return name.value;
};



// WEBPACK FOOTER //
// ./src/shared/helpers/gqlHelper.js